import ProdKitService from "@/services/ProdKitService";

export const prodKit = {
  namespaced: true,
  state: {
    prodKit: {},
  },
  actions: {
    getProdKit({ commit }, payload) {
      return ProdKitService.GetProdKit(payload).then(
        (prodKit) => {
          return Promise.resolve(prodKit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProdKit({ commit }, payload) {
      return ProdKitService.PostProdKit(payload).then(
        (prodKit) => {
          return Promise.resolve(prodKit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProdKit({ commit }, payload) {
      return ProdKitService.PutProdKit(payload).then(
        (prodKit) => {
          return Promise.resolve(prodKit);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProdKit({ commit }, payload) {
      return ProdKitService.DeleteProdKit(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdKitOData({ commit }, payload) {
      return ProdKitService.GetProdKitOData(payload).then(
        (prodKit) => {
          return Promise.resolve(prodKit);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default prodKit;
